// Cold/warm outreach email templates for freelance styling work (on-figure + still
// life). Tokens {{First Name}} and {{Studio}} are filled per contact; {{Portfolio Link}}
// and {{Site Link}} are auto-filled with live URLs on the resource page.

export const SIGNATURE = `Phaedra Paulson
Wardrobe & Prop Stylist · On-Figure & Still Life · NYC
{{Site Link}} · @mkingsleystudio`;

export const OUTREACH_TEMPLATES = [
  {
    id: "roster",
    name: "Studio — freelance roster",
    when: "Cold intro to e-comm / production studios with a freelance or talent route (The Line, Splashlight, Momentum, Kronus, Squareshot…).",
    subject: "Freelance stylist — on-figure & still life (NYC)",
    body: `Hi {{First Name}},

I'm Phaedra Paulson, a New York–based commercial stylist working across e-commerce, catalog and campaign. I style both on-figure / on-model apparel and still life / tabletop product, with a technical eye for fit, drape, fabric, proportion and color — stills are my primary focus, with motion as an added capability.

I'd love to be considered for {{Studio}}'s freelance stylist roster. I move quickly on a high-volume studio floor and I'm equally at home on a model set or building a clean product / flat-lay layout.

Portfolio (PDF): {{Portfolio Link}}
Full site: {{Site Link}}

Happy to send more references or stop by whenever it's useful. Thank you for the time.`,
  },
  {
    id: "boutique",
    name: "Boutique / luxury still-life studio",
    when: "Warmer, tailored pitch to boutique, luxury or still-life–led studios (Studio 309, Velorum, Materealist, Elena Vels…). Personalize the first line.",
    subject: "Wardrobe & prop styling — a fit for {{Studio}}",
    body: `Hi {{First Name}},

I've admired {{Studio}}'s work — {{one specific thing you like, e.g. your luxury still-life and PDP styling}}. I'm Phaedra Paulson, a NYC commercial stylist specializing in on-figure apparel and still life / product, with real garment expertise: fit, drape, fabric behavior, proportion and color.

Your mix of on-model and still-life work is exactly where I do my best styling, and I'd welcome the chance to freelance with your team.

A few examples: {{Portfolio Link}}
More at: {{Site Link}}

Would you be open to a quick call or a look at my book? Grateful for your consideration.`,
  },
  {
    id: "representation",
    name: "Representation / stylist management",
    when: "For artist reps & stylist management (Atelier Management, Art + Commerce / PRODn). Asking about representation, not a single booking.",
    subject: "Stylist seeking representation — commercial e-comm (on-figure & still life)",
    body: `Hi {{First Name}},

I'm Phaedra Paulson, a New York commercial stylist focused on e-commerce, catalog and campaign — on-figure apparel and still life / product, with strong technical garment skills (fit, drape, fabric, proportion, color) and motion capability.

I'm exploring representation and would love to know whether {{Studio}} is taking on stylists at the moment. My portfolio is here: {{Portfolio Link}} (full site: {{Site Link}}).

Happy to share references, rates and availability. Thank you for considering me.`,
  },
  {
    id: "followup",
    name: "Follow-up / bump",
    when: "Short nudge 5–7 business days after no reply. Send as a reply on the original thread so the subject stays 'Re:'.",
    subject: "Re: Freelance stylist — on-figure & still life",
    body: `Hi {{First Name}},

Circling back on my note about freelance styling with {{Studio}}. I'd still love to be considered for on-figure and still-life projects — here's my portfolio again in case it's handy: {{Portfolio Link}}.

Completely understand if the timing isn't right; happy to check back in a few months. Thanks so much!`,
  },
];
